<template>
    <b-container id="similar_jobs" class="section" v-if="jobs.length > 0">
        <b-row align-v="center">
            <b-col cols="12" lg="9">
                <div class="subsection">
                    <h2 class="section_title">
                        {{ $t("components.similarJobs.title") }}
                    </h2>
                </div>
            </b-col>

            <b-col cols="12" lg="3" />
        </b-row>

        <b-row align-v="center">
            <b-col cols="12" lg="9">
                <div class="subsection">
                    <div id="jobs">
                        <Job v-for="(job, i) in jobs" :key="i" :job="job" />
                    </div>
                </div>
            </b-col>

            <b-col cols="12" lg="3" />
        </b-row>
    </b-container>
</template>

<script>
import Jobs from "~/services/jobs";

import Job from "~/components/Jobs/Job";

export default {
    components: {
        Job,
    },
    data() {
        return {
            jobs: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loadData();
        },
        loadData() {
            new Jobs(this.$axios)
                .similar({
                    id: this.$store.state.jobs.job.id,
                })
                .then(response => {
                    this.jobs = response.payload;
                });
        },
    },
};
</script>
